<template>
  <modal
    :show.sync="show"
    footerClasses="justify-content-center"
    type="notice"
    ref="shiftFastCreator"
  >
    <!-- @close="handleShiftCreationModalClose()" -->
    <h5 slot="header" class="modal-title">
      {{ editShift ? "VISUALIZADOR DE TURNO" : "EDITAR TURNO" }}
    </h5>
    <div d-flex>
      <fg-input
        type="text"
        label="Nombre Turno"
        class=""
        v-model="shiftData.descripcionTurno"
        placeholder=""
        :readonly="editShift"
      >
      </fg-input>
    </div>
    <div class="d-flex flex-column py-2">
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Lunes</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.lunesAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.lunesAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.lunesHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.lunesAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.lunesHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Martes</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.martesAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.martesAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.martesHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.martesAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.martesHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Miercoles</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.miercolesAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.miercolesAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.miercolesHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.miercolesAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.miercolesHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Jueves</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.juevesAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.juevesAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.juevesHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.juevesAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.juevesHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Viernes</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.viernesAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.viernesAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.viernesHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.viernesAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.viernesHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2 border-bottom">
        <div class="col-md-4">
          <p class="card-title">Sabado</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.sabadoAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.sabadoAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.sabadoHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.sabadoAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.sabadoHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
      <div class="row mr-2">
        <div class="col-md-4">
          <p class="card-title">Domingo</p>
          <p-switch
            :disabled="editShift"
            v-model="shiftData.domingoAutorizado"
            type="success"
            on-text="SI"
            off-text="NO"
          ></p-switch>
        </div>
        <div v-if="shiftData.domingoAutorizado" class="col-md-4">
          <p class="card-title">Inicio</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.domingoHoraInicio"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de inicio"
            >
            </el-time-select>
          </div>
        </div>
        <div v-if="shiftData.domingoAutorizado" class="col-md-4">
          <p class="card-title">Fin</p>
          <div class="form-group">
            <el-time-select
              size="small"
              :disabled="editShift"
              v-model="shiftData.domingoHoraTermino"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:59',
              }"
              placeholder="     Hora de termino"
            >
            </el-time-select>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-flex flex-row justify-content-center">
      <p-button type="success" class="mr-2" @click="submitshiftDataModal()"
        >OK</p-button
      >
      <p-button @click="cancelshiftDataModal()" type="danger"
        >CANCELAR</p-button
      >
    </div> -->
  </modal>
</template>

<script>
import { Badge, Modal } from "src/components/UIComponents";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
} from "element-ui";
export default {
  name: "ShiftUpdateModal",
  components: {
    [Select.name]: Select,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    Modal,
    Badge,
    PSwitch,
    // [Tooltip.name]: Tooltip,
  },
  props: {
    shiftData: {
      type: Object,
      default: () => ({
        idTurno: 0,
        lunesAutorizado: true,
        martesAutorizado: true,
        miercolesAutorizado: true,
        juevesAutorizado: true,
        viernesAutorizado: true,
        sabadoAutorizado: true,
        domingoAutorizado: true,
        descripcionTurno: "TURNO DEFAULT",
        lunesHoraInicio: "09:30:00",
        lunesHoraTermino: "19:00:00",
        martesHoraInicio: "09:30:00",
        martesHoraTermino: "19:00:00",
        miercolesHoraInicio: "09:30:00",
        miercolesHoraTermino: "19:00:00",
        juevesHoraInicio: "09:30:00",
        juevesHoraTermino: "19:00:00",
        viernesHoraInicio: "09:30:00",
        viernesHoraTermino: "19:00:00",
        sabadoHoraInicio: "09:30:00",
        sabadoHoraTermino: "19:00:00",
        domingoHoraInicio: "09:30:00",
        domingoHoraTermino: "19:00:00",
      }),
    },
    editShift: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
  },
  watch: {
    showProp: function (newValue) {
      // console.log("changin");
      this.show = newValue;
    },
  },
};
</script>

<style></style>
